import { SuggestionKind } from 'owa-search-service';
export var SUPPORTED_FILESHUB_SUGGESTION_KIND_LIST = [
    SuggestionKind.Files,
    SuggestionKind.People,
    SuggestionKind.Keywords,
];
export var ALL_SUGGESTION_KINDS_LIST = [
    SuggestionKind.Files,
    SuggestionKind.People,
    SuggestionKind.Keywords,
    SuggestionKind.Command,
    SuggestionKind.Message,
    SuggestionKind.Category,
];
//# sourceMappingURL=constants.js.map